import React from "react";
import dayjs from "dayjs";
export function ActivityEntry({ icon, label, createdAt }) {
    return (React.createElement("div", { className: "flex gap-4 p-2" },
        React.createElement("div", { className: "text-sm my-auto" },
            React.createElement("img", { alt: "order-activity-icon", src: icon })),
        React.createElement("div", null,
            React.createElement("div", { className: "flex flex-col gap-2 my-auto" },
                React.createElement("div", { className: "text-primary" }, label),
                React.createElement("div", { className: "text-dark-gray text-sm" }, dayjs(createdAt).format("DD MMM, YYYY HH:mm A"))))));
}
